module.exports = __webpack_public_path__ + "img/about_illustration.6493a833.png";